const initMMM = () => {
  const wrapper = document.getElementById('mmm-btn-wrapper');
  if (!wrapper) return;

  const skus = wrapper.dataset.mmmSkus || '';

  const handleEntryDisplay = () => {
    const observer = new MutationObserver(mutations => {
      mutations.forEach(m => {
        if (m.target.style.display !== 'none') {
          wrapper.style.display = 'flex';
          observer.disconnect();
        }
      });
    });
    const findBtn = document.getElementById('findShadeMMM');
    if (findBtn) observer.observe(findBtn, { attributes: true, attributeFilter: ['style'] });
  };

  const normalizeShade = name => name.replace(/\.0$/, '').trim();

  const selectShade = name => {
    const normalized = normalizeShade(name);
    const inputs = Array.from(document.querySelectorAll('[data-variant-input]'));
    const input = inputs.find(i => i.value === normalized)
      ?? inputs.find(i => normalizeShade(i.value).toLowerCase() === normalized.toLowerCase());
    if (input) {
      input.click();
    } else {
      console.warn('[MMM] No matching shade for:', JSON.stringify(name), '| Available:', inputs.map(i => i.value));
    }
    return !!input;
  };

  if (!document.getElementById('mmmwidgets')) {
    document.MMMWidget = document.MMMWidget || {};

    const s = document.createElement('script');
    s.defer = true;
    s.id = 'mmmwidgets';
    s.setAttribute('referrerpolicy', 'origin');
    s.src = `https://www.matchmymakeup.com/client/S2FzaCBCZWF1dHk=/mmm_widget.js?${skus}`;
    document.head.appendChild(s);

    document.MMMWidget.selectShade = product => selectShade(product.productName);

    handleEntryDisplay();
  }

  window.addEventListener('message', event => {
    if (event.origin !== 'https://stage.matchmymakeup.com' && event.origin !== 'https://www.matchmymakeup.com') return;
    const msg = event.data;
    if (msg.event_id !== 'add_to_cart') return;
    const found = selectShade(msg.product.productName);
    if (!found) {
      alert(`${msg.product.productName} could not be selected — the item may not be available in the store.`);
    }
    if (document.mmm?.overlay) document.mmm.overlay.close();
  });
};

export default initMMM;
